export default function (element, data) {
    element.addEventListener("click", function (event) {
        let block = document.querySelector(".popup-form-container.form-popup");
        if(block){
            window.dispatchEvent(new CustomEvent('openformpopup'));
        }
        else{
            window.location.href=element.dataset.link + "#formRequest";
        }
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
